import { createReducer } from 'reduxsauce';
import { APP_SETTINGS } from 'actions/Base';

export const INITIAL_STATE = {
  selectedHitClub: 0,
  sidebarCollapsed: false
};

export const onSetRequest = (state, { params }) => ({ ...state, isLoading: true, sidebarCollapsed: params.sidebarCollapsed });

export const onSetSelectedHitClubRequest = (state, { params }) => ({ ...state, selectedHitClub: params.hitClubId });

export const onResetRequest = () => INITIAL_STATE;

export const ACTION_HANDLERS = {
  [APP_SETTINGS.SET_REQUEST]: onSetRequest,
  [APP_SETTINGS.RESET_REQUEST]: onResetRequest,
  [APP_SETTINGS.SET_SELECTED_HITCLUB_REQUEST]: onSetSelectedHitClubRequest,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
